var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "user-bind-modal",
      attrs: {
        title: "",
        visible: _vm.show,
        "close-on-click-modal": false,
        width: "550px",
        bodyHeight: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.drawRow.type === "add"
                ? _vm.$t("shop-site::email::addEmail_title")
                : _vm.$t("shop-site::email::editEmail_title")
            ) +
            " "
        ),
      ]),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showEmailForm,
              expression: "!showEmailForm",
            },
          ],
          attrs: { gutter: 16 },
        },
        _vm._l(_vm.emailList, function (item) {
          return _c("el-col", { key: item.mailboxType, attrs: { span: 8 } }, [
            _c("div", { staticClass: "emailType" }, [
              _c("img", {
                attrs: { src: item.imageUrl },
                on: {
                  click: function ($event) {
                    return _vm.selectDefaultEmail(item)
                  },
                },
              }),
            ]),
          ])
        }),
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEmailForm,
              expression: "showEmailForm",
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "email-body",
          attrs: {
            model: _vm.params,
            rules: _vm.rules,
            "label-width": "150px",
            "hide-required-asterisk": "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sec-box no-bg" },
            [
              _vm.drawRow.type === "add"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "110px",
                        label: _vm.$t("shop-site::email::table_shop") + "：",
                        prop: "shopId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input-item",
                          attrs: {
                            popperAppendToBody: false,
                            filterable: "",
                            disabled: _vm.drawRow.type !== "add",
                            placeholder: _vm.$t(
                              "shop-site::email::placeholder_shop"
                            ),
                          },
                          on: { change: _vm.changeShop },
                          model: {
                            value: _vm.params.shopId,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "shopId", $$v)
                            },
                            expression: "params.shopId",
                          },
                        },
                        _vm._l(_vm.shopIds, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "110px",
                        label: _vm.$t("shop-site::email::table_shop") + "：",
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$dataCheck(_vm.params.shopName)) + " "
                      ),
                    ]
                  ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "110px",
                    label: _vm.$t("shop-site::email::form_platform") + "：",
                    prop: "platform",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-item",
                      attrs: {
                        popperAppendToBody: false,
                        disabled: !!_vm.params.shopId,
                        filterable: "",
                        placeholder: _vm.$t(
                          "shop-site::email::placeholder_platform"
                        ),
                      },
                      model: {
                        value: _vm.params.platform,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "platform", $$v)
                        },
                        expression: "params.platform",
                      },
                    },
                    _vm._l(_vm.platformLists, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "110px",
                    label: _vm.$t("shop-site::email::form_staff") + "：",
                    prop: "staffId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-item",
                      attrs: {
                        popperAppendToBody: false,
                        filterable: "",
                        placeholder: _vm.$t(
                          "shop-site::email::placeholder_staff"
                        ),
                      },
                      model: {
                        value: _vm.params.staffId,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "staffId", $$v)
                        },
                        expression: "params.staffId",
                      },
                    },
                    _vm._l(_vm.users, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "110px",
                    label: _vm.$t("shop-site::email::form_account") + "：",
                    prop: "inUser",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "input-item",
                    attrs: {
                      placeholder: _vm.$t(
                        "shop-site::email::placeholder_account"
                      ),
                    },
                    model: {
                      value: _vm.params.inUser,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.params,
                          "inUser",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "params.inUser",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { "label-width": "110px", prop: "inPassword" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("shop-site::email::form_password")) +
                          "： "
                      ),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "bottom" },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("shop-site::email::qq_tip")) +
                                  " "
                              ),
                              _c("br"),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://service.mail.qq.com/cgi-bin/help?subtype=1&&id=28&&no=1001256",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    " https://service.mail.qq.com/cgi-bin/ "
                                  ),
                                  _c("br"),
                                  _vm._v(" help?subtype=1&&id=28&&no=1001256 "),
                                ]
                              ),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("shop-site::email::auth_tip")) +
                                  " "
                              ),
                            ]
                          ),
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.params.inServer &&
                                  _vm.params.inServer.includes("qq"),
                                expression:
                                  "params.inServer && params.inServer.includes('qq')",
                              },
                            ],
                            staticClass: "icon-a-01wenhao iconfont-el",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-input", {
                    staticClass: "input-item",
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t(
                        "shop-site::email::placeholder_password"
                      ),
                      "show-password": true,
                    },
                    model: {
                      value: _vm.params.inPassword,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.params,
                          "inPassword",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "params.inPassword",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "p",
            {
              staticStyle: {
                "text-align": "center",
                "margin-bottom": "16px",
                padding: "10px 0",
                background: "#f9f9f9",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      _vm.showMore = !_vm.showMore
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("shop-site::email::moreSetting")) + " "
                  ),
                  _c("i", {
                    staticClass: "iconfont down-icon iconicon_arrow02",
                    class: { "rotate-arrow": _vm.showMore },
                  }),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMore,
                  expression: "showMore",
                },
              ],
              staticClass: "sec-box",
            },
            [
              _c("div", { staticClass: "sec-header" }, [
                _vm._v(_vm._s(_vm.$t("shop-site::email::sendSetting"))),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::email::table_sendType") + "：",
                    prop: "outAccountType",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-item",
                      attrs: {
                        popperAppendToBody: false,
                        placeholder: _vm.$t(
                          "shop-site::email::placeholder_emailType"
                        ),
                        "popper-append-to-body": false,
                      },
                      model: {
                        value: _vm.params.outAccountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "outAccountType", $$v)
                        },
                        expression: "params.outAccountType",
                      },
                    },
                    _vm._l(_vm.emailTypes, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::email::table_sendAddress") + "：",
                    prop: "outServer",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "input-item",
                    attrs: {
                      placeholder: _vm.$t("shop-site::email::table_sendPort"),
                    },
                    model: {
                      value: _vm.params.outServer,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.params,
                          "outServer",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "params.outServer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::email::table_sendPort") + "：",
                    prop: "outPort",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "input-item",
                    attrs: {
                      placeholder: _vm.$t(
                        "shop-site::email::placeholder_emailPort"
                      ),
                    },
                    model: {
                      value: _vm.params.outPort,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.params,
                          "outPort",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "params.outPort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::email::table_protocol") + "：",
                    prop: "outProtocol",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-item",
                      attrs: {
                        popperAppendToBody: false,
                        placeholder: _vm.$t(
                          "shop-site::email::placeholder_protocol"
                        ),
                        "popper-append-to-body": false,
                      },
                      model: {
                        value: _vm.params.outProtocol,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "outProtocol", $$v)
                        },
                        expression: "params.outProtocol",
                      },
                    },
                    _vm._l(_vm.protocols, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMore,
                  expression: "showMore",
                },
              ],
              staticClass: "sec-box",
            },
            [
              _c("div", { staticClass: "sec-header" }, [
                _vm._v(_vm._s(_vm.$t("shop-site::email::recieveSetting"))),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::email::table_recieveType") + "：",
                    prop: "inAccountType",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-item",
                      attrs: {
                        popperAppendToBody: false,
                        placeholder: _vm.$t(
                          "shop-site::email::placeholder_emailType"
                        ),
                        "popper-append-to-body": false,
                      },
                      model: {
                        value: _vm.params.inAccountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "inAccountType", $$v)
                        },
                        expression: "params.inAccountType",
                      },
                    },
                    _vm._l(_vm.emailTypes, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.$t("shop-site::email::table_recieveAddress") + "：",
                    prop: "inServer",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "input-item",
                    attrs: {
                      placeholder: _vm.$t(
                        "shop-site::email::placeholder_emailAddress"
                      ),
                    },
                    model: {
                      value: _vm.params.inServer,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.params,
                          "inServer",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "params.inServer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::email::table_recievePort") + "：",
                    prop: "inPort",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "input-item",
                    attrs: {
                      placeholder: _vm.$t(
                        "shop-site::email::placeholder_emailPort"
                      ),
                    },
                    model: {
                      value: _vm.params.inPort,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.params,
                          "inPort",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "params.inPort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("shop-site::email::table_protocol") + "：",
                    prop: "inProtocol",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-item",
                      attrs: {
                        popperAppendToBody: false,
                        placeholder: _vm.$t(
                          "shop-site::email::placeholder_protocol"
                        ),
                        "popper-append-to-body": false,
                      },
                      model: {
                        value: _vm.params.inProtocol,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "inProtocol", $$v)
                        },
                        expression: "params.inProtocol",
                      },
                    },
                    _vm._l(_vm.protocols, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEmailForm,
              expression: "showEmailForm",
            },
          ],
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onSave },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }